export default "__VITE_ASSET__BAXELvSy__"